import * as types from './actionTypes';

// fetch CommercialProductsV2
export function fetchCommercialProductsV2() {
  return {
    type: types.FETCH_COMMERCIAL_PRODUCTS_V2_REQUEST,
  };
}

export function fetchCommercialProductsV2Success({ data }) {
  return {
    type: types.FETCH_COMMERCIAL_PRODUCTS_V2_SUCCESS,
    data,
  };
}

export function fetchCommercialProductsV2Fail({ error }) {
  return {
    type: types.FETCH_COMMERCIAL_PRODUCTS_V2_FAIL,
    error,
  };
}

// fetch CommercialProduct
export function fetchCommercialProduct({ id }) {
  return {
    type: types.FETCH_COMMERCIAL_PRODUCT_REQUEST,
    id,
  };
}

export function fetchCommercialProductSuccess({ data, id }) {
  return {
    type: types.FETCH_COMMERCIAL_PRODUCT_SUCCESS,
    data,
    id,
  };
}

export function fetchCommercialProductFail({ error, id }) {
  return {
    type: types.FETCH_COMMERCIAL_PRODUCT_FAIL,
    error,
    id,
  };
}
